import { Component, OnInit, OnDestroy, inject, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { initializeExtensionErrorHandling } from './core/utils/extension-error-handler';
import { AnalyticsConsentService } from './core/services/analytics-consent.service';
import { LoggingService } from './core/services/logging.service';
import { UserActivityLoggingService } from './core/services/user-activity-logging.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private platformId = inject(PLATFORM_ID);
  private consent = inject(AnalyticsConsentService);
  private logging = inject(LoggingService);
  private activityLogging = inject(UserActivityLoggingService);

  title = 'scan-ninja-dashboard';
  private gtmInjected = false;
  private subscription?: Subscription;

  ngOnInit(): void {
    // Initialize extension error handling to suppress harmless browser extension errors
    initializeExtensionErrorHandling();

    // Initialize user activity logging
    this.activityLogging.logSessionStart();
    this.activityLogging.logPageView('app-root', { application: 'scan-ninja-dashboard' });

    // Only inject GTM when running in production and marketing consent has been granted
    if (environment.production) {
      // If consent already exists, inject immediately; otherwise subscribe to consent changes
      if (this.consent.isConsented()) {
        this.injectGoogleTag();
      } else {
        // Subscribe to consent changes - the centralized cookie notification component will handle UI
        this.subscription = this.consent
          .onConsentChange()
          .subscribe((granted: boolean) => {
            if (granted) {
              this.injectGoogleTag();
            }
          });
      }
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private injectGoogleTag() {
    // Only inject GTM in browser context
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    
    if (this.gtmInjected) {
      return;
    }
    this.gtmInjected = true;
    if (isPlatformBrowser(this.platformId)) {
      const script = document.createElement('script');
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-W8ZLBHHT');`;
      document.head.appendChild(script);
    }
  }
}
